export default __webpack_public_path__ + "static/media/societe-generale.e8040f22.png";